import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PROCESS } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const StepCard = ({ step }) => (
  <motion.div
    whileHover={{ y: -8 }}
    transition={{ duration: 0.35, ease: EASE }}
    className="group relative bg-white rounded-3xl border border-zinc-200 overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 h-full flex flex-col"
    data-testid={`process-step-${step.no}`}
  >
    <div className="relative aspect-[4/3] overflow-hidden">
      <motion.img
        src={step.image}
        alt={step.title}
        loading="lazy"
        className="h-full w-full object-cover"
        whileHover={{ scale: 1.06 }}
        transition={{ duration: 0.6, ease: EASE }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent" />
      <span className="absolute top-4 left-4 h-10 w-10 rounded-full bg-forest text-white font-mono text-sm font-semibold flex items-center justify-center shadow-lg">
        {step.no}
      </span>
    </div>
    <div className="p-6 flex-1 flex flex-col">
      <h3 className="text-xl font-bold tracking-tight text-ink">{step.title}</h3>
      <p className="mt-2 text-sm text-zinc-500 leading-relaxed">{step.copy}</p>
    </div>
  </motion.div>
);

export const Process = () => (
  <section id="process" className="py-24 sm:py-32 bg-white border-y border-zinc-200" data-testid="process">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest mb-4">Our Simple 5-Step Process</p>
          <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tighter text-ink leading-[1.05]">
            How Sahi Claim Works
          </h2>
        </div>
      </Reveal>

      {/* Desktop: horizontal timeline with arrows */}
      <div className="hidden lg:flex items-stretch gap-2">
        {PROCESS.map((step, i) => (
          <div key={step.no} className="flex items-center flex-1 min-w-0">
            <Reveal delay={i * 0.1} className="flex-1 min-w-0">
              <StepCard step={step} />
            </Reveal>
            {i < PROCESS.length - 1 && (
              <div className="shrink-0 px-1 text-forest">
                <ArrowRight size={22} strokeWidth={2.5} />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Mobile / tablet: vertical timeline with arrows */}
      <div className="lg:hidden flex flex-col items-stretch gap-0 max-w-md mx-auto">
        {PROCESS.map((step, i) => (
          <div key={step.no} className="flex flex-col">
            <Reveal delay={i * 0.05}>
              <StepCard step={step} />
            </Reveal>
            {i < PROCESS.length - 1 && (
              <div className="flex justify-center py-4 text-forest">
                <ArrowDown size={22} strokeWidth={2.5} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
